import styled from 'styled-components'

const WarningMessage = styled.span`
  display: block;

  font-size: 0.8125rem;

  margin-top: 30px; /* stylelint-disable-line scales/space */
  padding: 0 60px; /* stylelint-disable-line scales/space */
  text-align: center;

  color: ${({ theme }) => theme.colors.text.dark.secondary};
`

export default WarningMessage
